export default __webpack_public_path__ + "static/quotes-row-4974622588c200f9657294be361c81d4.png";